import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { State } from 'vuex-class'

import { ApolloResponse } from '@/interfaces/apollo'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { showErrors } from '@/utils/snack'
import { parsePhoneNumber } from '@/utils/phoneNumberFormat'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppListSearchBtn from '@/components/AppListSearchBtn.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import { getCallLogs } from '@/modules/PhoneLog/gql/phone.gql'
import { PhoneLog } from '@/modules/PhoneLog/interfaces/phone-log'
import ListPage from '@/mixins/list-page'
import CallerDialog from '@/modules/PhoneLog/components/callerDialog.vue'
import { dateTimeToDisplay } from '@/utils/dateTime'
import AppFilterButton from '@/components/AppFilterButton.vue'
import AppSimpleTextField from '@/components/AppSimpleTextField.vue'
import AppSimpleSelector from '@/components/AppSimpleSelector.vue'
import AppSimpleTextSearch from '@/components/AppSimpleTextSearch.vue'
import AppSimpleDatePicker from '@/components/AppSimpleDatePicker.vue'
import { PageState } from '../../../store/modules/page'

@Component({
  components: {
    AppBreadcrumbs,
    AppTextField,
    AppSelector,
    AppListSearchBtn,
    CallerDialog,
    AppDatePicker,
    AppFilterButton,
    AppSimpleTextField,
    AppSimpleSelector,
    AppSimpleTextSearch,
    AppSimpleDatePicker
  }
})

export default class PhoneLogList extends mixins(ListPage) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Phone Log List'
    }
  ]

  directionOptions = ['inbound', 'outbound']

  disableConfirm = false

  tableColumn = [
    { field: 'direction', title: 'Direction', resizable: true },
    { field: 'from', title: 'From', slots: { default: 'from_default' }, sortable: true, resizable: true },
    { field: 'to', title: 'To', slots: { default: 'to_default' }, sortable: true, resizable: true },
    { field: 'time', title: 'Time', slots: { default: 'time_default' }, sortable: true, resizable: true },
    { field: 'result', title: 'Result', resizable: true },
    { field: 'path', title: 'Path', resizable: true },
    { field: 'duration', title: 'Duration', fixed: 'right' }
  ]

  phoneLogs: PhoneLog[] = []

  parsePhoneNumber = parsePhoneNumber
  dateTimeToDisplay = dateTimeToDisplay

  windowSize = {
    w: 0,
    h: 0
  }

  orderBy: {
    [key: string]: string
  } = {
    from: 'FROM',
    to: 'TO',
    time: 'TIME'
  }

  tableLoading = false

  newCaseDialog = false

  targetPhone = ''

  accountDialog = {
    show: false,
    title: '',
    highlightTitle: ''
  }

  @State(state => state.page) page!: PageState

  async created () {
    await this.restorePage(this.page[this.$route.name || ''])
  }

  async mounted () {
    await this.restorePage(this.page[this.$route.name || ''])
    this.getPhoneLogs()
  }

  async getPhoneLogs () {
    const { sortBy, sortDesc, tablePage } = this.options
    const { currentPage, pageSize } = tablePage
    const orderBy = this.orderBy[sortBy] || 'TIME'
    const filter: {
      [key: string]: any;
    } = {}
    if (this.filter.from) {
      filter.from = this.filter.from.toString()
    }
    if (this.filter.to) {
      filter.to = this.filter.to.toString()
    }
    if (this.filter.direction) {
      filter.direction = this.directionOptions[this.filter.direction]
    }
    if (this.filter.name) {
      filter.name = this.filter.name
    }
    if (this.filter.number) {
      filter.number = this.filter.number
    }
    this.tableLoading = true
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCallLogs,
        variables: {
          filter,
          order: {
            orderBy: orderBy,
            asc: !sortDesc
          },
          paging: {
            offset: (currentPage - 1) * pageSize,
            limit: pageSize
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      for (var i = 0; i < result.data.getCallLogs.logs.length; i++) {
        if (result.data.getCallLogs.logs[i].detailStr) {
          const detail = JSON.parse(result.data.getCallLogs.logs[i].detailStr)
          result.data.getCallLogs.logs[i].path = detail.path
        }
      }
      this.tableLoading = false
      this.phoneLogs = result.data.getCallLogs.logs
      this.options.tablePage.total = result.data.getCallLogs.paging.totalCount
      this.storePage()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  onResize () {
    this.windowSize = { w: window.innerWidth, h: window.innerHeight }
  }

  routeToAccountDetail (item: any) {
    return {
      name: 'AccountDetailDetail',
      params: {
        id: item.accountId
      }
    }
  }

  routeToContactDetail (item: any) {
    return {
      name: 'ContactDetailDetail',
      params: {
        id: item.contactId
      }
    }
  }

  sortTable (column: any) {
    this.options.sortBy = column.property
    this.options.sortDesc = column.order === 'desc'
    this.getPhoneLogs()
  }

  handlePageChange (pageData: any) {
    this.options.tablePage.currentPage = pageData.currentPage
    this.options.tablePage.pageSize = pageData.pageSize
    this.getPhoneLogs()
  }

  callDetailHandler (phone: string) {
    if (phone.indexOf('+') !== -1) {
      this.targetPhone = phone
      this.accountDialog.show = true
    }
  }

  handleCancel () {
    this.accountDialog.show = false
  }
}
